module.exports = __webpack_public_path__ + "static/img/f8.066af31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/f8.png
// module id = fMd+
// module chunks = 2